import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationES from 'shared/locales/messages/es.json';
import translationEN from 'shared/locales/messages/en.json';
import translationCAT from 'shared/locales/messages/cat.json';
import translationEusk from 'shared/locales/messages/eusk.json';

const resources = {
  es: {
    translation: translationES,
  },
  en: {
    translation: translationEN,
  },
  'es-ES': {
    translation: translationES,
  },
  'en-US': {
    translation: translationEN,
  },
  'ca-ES': {
    translation: translationCAT,
  },
  'eu-ES': {
    translation: translationEusk,
  },
};

i18n
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    resources,
    fallbackLng: ['es', 'en', 'es-ES', 'en-US', 'ca-ES', 'eu-ES'],
  });

export default i18n;
